import { createFileRoute } from "@tanstack/react-router";
import { Cheatsheet } from "@/lms/playground/Cheatsheet";
import DarkModeSwitch from "@/components/nav/DarkModeSwitch";
import { useCourse } from "@/lib/store";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
export const Route = createFileRoute("/_auth/course/$courseId/cheatsheet")({
  component: RouteComponent,
});

function RouteComponent() {
  const course = useCourse();

  const [sheet, setSheet] = useState(course?.cheatsheet)

  function expand(on = true) {
    if (!course?.cheatsheet) return;

    const openState = on ? 'true' : 'false';
    const oppositeState = on ? 'false' : 'true';
    const updated = course.cheatsheet.replace(
      new RegExp(`defaultOpen=\\{${oppositeState}\\}`, 'g'),
      `defaultOpen={${openState}}`
    );

    setSheet(updated);
  }

  useEffect(() => {
    setSheet(course?.cheatsheet)
  },[course])
  
  return (
    <div>
      <div className="flex w-full justify-end">
        <div className="ms-4">
          <Button variant="outline" className="h-6 px-4 text-foreground " onClick={expand}>
            Expand all
          </Button>
          <Button variant="outline" className="h-6 px-4 text-foreground " onClick={()=>expand(false)}>
            Collapse all
          </Button>
        </div>
        <DarkModeSwitch />
      </div>
      <Cheatsheet cheatsheet={sheet? sheet : ""}/>
    </div>
  );
}
